var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, isValidElement } from 'react';
import { Th, Thead, Tr } from '@patternfly/react-table';
import { Skeleton } from '@patternfly/react-core';
export const isThObject = (value) => value != null && typeof value === 'object' && 'cell' in value;
export const isReactElement = (value) => isValidElement(value);
export const SkeletonTableHead = (_a) => {
    var { ouiaId = 'SkeletonTableHeader', isSelectable, isExpandable, columnsCount, columns, isTreeTable } = _a, rest = __rest(_a, ["ouiaId", "isSelectable", "isExpandable", "columnsCount", "columns", "isTreeTable"]);
    const hasCustomColumns = Array.isArray(columns);
    const rowCellsCount = hasCustomColumns ? columns.length : columnsCount;
    const cells = useMemo(() => [
        ...(isExpandable ? [_jsx(Th, { screenReaderText: 'Data expansion table header cell' }, "row-expand")] : []),
        ...(isSelectable && !isTreeTable ? [_jsx(Th, { screenReaderText: 'Data selection table header cell' }, "row-select")] : []),
        ...(hasCustomColumns ? (columns.map((column, index) => {
            // If the column is an object with cell and props, wrap in Th
            if (isThObject(column)) {
                return (_jsx(Th, Object.assign({}, column.props, { "data-ouia-component-id": `${ouiaId}-th-${index}`, children: column.cell }), index));
            }
            // If the column is already a React element (like <Th>), render it directly
            if (isReactElement(column)) {
                return column;
            }
            // Otherwise, wrap the content in Th
            return (_jsx(Th, { "data-ouia-component-id": `${ouiaId}-th-${index}`, children: column }, index));
        })) : ([...Array(rowCellsCount)].map((_, index) => (_jsx(Th, { "data-ouia-component-id": `${ouiaId}-th-${index}`, children: _jsx(Skeleton, {}) }, index)))))
    ], [hasCustomColumns, isExpandable, isSelectable, isTreeTable, columns, rowCellsCount, ouiaId]);
    return (_jsx(Thead, Object.assign({ "data-ouia-component-id": `${ouiaId}-thead` }, rest, { children: _jsx(Tr, { ouiaId: `${ouiaId}-tr-head`, children: cells }) })));
};
export default SkeletonTableHead;
